import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import http from 'http'

import { getUser } from 'context/Profile/constants'

import { FiLock, FiEye, FiEyeOff, FiUser } from 'react-icons/fi'

const Login = () => {
  const navigate = useNavigate()
  const user = getUser()

  const [ unsafe, setUnsafe ] = useState( false )
  const [ model, setModel ] = useState( {
    user_id: user.id,
    username: '',
    password: '',
    _43v3r: false
  } )

  const login = ( e ) => {
    e.preventDefault()

    http( {
      method: 'POST',
      url: '/auth/login',
      data: { ...model }
    } )
      .then( ( { data } ) => {
        const { __error } = data

        if ( __error )
          return alert( 'not authorized' )

        localStorage.setItem( 'token', data.token )

        setTimeout( () => {
          navigate( '/' )
        }, 1000 )
      } )
      .catch( err => {
        navigate( '/info' )
      } )
  }

  const toggleUnsafe = () => {
    setUnsafe( ! unsafe )
  }

  const handleModelUpdate = ( e ) => {
    let { name, value, type, checked } = e.target

    if ( type === 'checkbox' )
      value = checked

    setModel( { ...model, [ name ]: value } )
  }

  return <div className="one hs gap-2x">
    <div className="one hs jc-center air-2x gap-2x in-air-2x bg-secondary">
      <form onSubmit={ login } className="hs gap-4x">
        { ! user.id ? <div className="bar">
          <div className="icon">
            <FiUser />
          </div>

          <input
            name="username"
            value={ model.username }
            onChange={ handleModelUpdate }
            size={ 1 }
            placeholder="username"
            className="one"
            required
          />
        </div> : null }


        <div className="bar">
          <div className="icon">
            <FiLock />
          </div>

          <input
            name="password"
            type={ unsafe ? 'text' : 'password' }
            value={ model.password }
            onChange={ handleModelUpdate }
            size={ 1 }
            placeholder="password"
            className="one"
            required
          />

          <button
            type="button"
            onClick={ toggleUnsafe }
          >
            { unsafe ? <FiEyeOff /> : <FiEye /> }
          </button>
        </div>

        <div className="vs reverse gap">
          <label for="_43v3r">
            remember me
          </label>

          <input
            id="_43v3r"
            name="_43v3r"
            type="checkbox"
            value={ model._43v3r }
            onChange={ handleModelUpdate }
          />

        </div>

        <div className="bar form-button">
          <button
            className="bt-accent"
          >
            enter
          </button>
        </div>
      </form>
    </div>
  </div>
}

export default Login
